// src/components/contact/ContactHero.jsx
import { Wrap, Brand, Bar, Crumbs, Ornament } from "./ContactHeroStyles";

export default function ContactHero({ brand }) {
  return (
    <Wrap>
      <Brand>{brand}</Brand>
      <Ornament />
      <Crumbs>
        {/* <span>Acasă</span> <span>/</span> <strong>Contact</strong> */}
      </Crumbs>
    </Wrap>
  );
}
